/**
 * SlxControls 1.2.41 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */
/**
 * SlxDateSelector class.
 * @requires slx.core
 * @requires slx.calendar
 * @class slx.dateSelector
 */
var SlxDateSelector = (function (global) {
	'use strict';
	var x = global.SlxControl;

	/**
	 * slx.dateSelector
	 * @constructs
	 */
	x.slx.dateSelector = function () {
		var that = this;
		x.slx.base.apply(that, arguments);

		// reference current element
		var el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		// get date locale and language
		var _getLocale = function(lang) {
			if (!Date['locale']) {
				return {};
			} else if (!lang) {
				return Date['locale'];
			}

			return Date['locale'][lang] || {};
		};

		// set custom settings from data props and attributes
		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		that.container = x(that.selector + '_container');
		that.showIcon = that.showIcon === false || el.data('showicon') === false ? false : true;
		that.icon = that.icon || 'glyphicons glyphicons-calendar';
		that.onChange = typeof that.onChange === 'function' ? that.onChange : el.attr('onchange') !== void 0 ? x.eval.call(el[0], el.attr('onchange'), 'event') : void 0;
		that.view = that.view || el.data('view') || 'month';
		that.lang = that.lang && that.lang in _getLocale() ? that.lang : 'en';
		that.format = that.format || el.data('format') || _getLocale(that.lang).format;
		that.calendar = null;
		that.mask = that.mask || el.data('mask') || '__/__/____';
		that.mobileMaxWidth = that.mobileMaxWidth || el.data('mobile-maxwidth') || 767;
		that.html5 = that.html5 === false || el.data('html5') === false ? false : true;
		that.readonly = el.prop('readonly');
		that.disabled = el.prop('disabled');

		// local flags and references
		var _isMobile = false, _dateSupported = null;
		var _btn = this.container.find('.slx-dateselector-icon');

		// fill the element with remaining chars in mask
		var _fillMask = function (char) {
			var v = el.val().replace(/[\D]/g, ''), val;
			v += char || '', val = '';
			// loop through mask chars
			for (var i = 0, n = 0; i < that.mask.length; i++) {
				var j = that.mask.charAt(i);
				if (/[\/-]/.test(j)) { val += j; continue; }
				val += n < v.length ? v.charAt(n) : j;
				n++;
			}
			return val;
		};

		// feature detection for HTML5 date inputs
		var _testDateSupport = function () {
			if (!that.html5) { return false; }
			try {
				// test support for date inputs
				var input = document.createElement('INPUT');
				input.type = 'date';
				return input.type === 'date';
			} catch (e) {
				// date inputs not supported
				return false;
			}
		};

		// get date format based on mobile, HTML5 enabled, and date input support
		var _getFormat = function () {
			return that.html5 && _isMobile && _dateSupported ? 'yyyy-MM-dd' : that.format;
		};

		// set input type based on HTML5 enabled and date input support
		var _previousType = null;
		var _setInputType = function () {
			if (_dateSupported === null) { _dateSupported = _testDateSupport(); }
			var t = that.dateValue();
			if (_isMobile && _dateSupported) {
				if (el.prop('type') !== 'date') {
					if (_previousType !== null) {
						_previousType = el.prop('type');
					}
					that.changeFormat();
				} else {
					return;
				}

				// set type when in mobile mode if date input supported
				if (el.slxVal().length) {
					el.slxVal(t.toString(_getFormat()));
				}
				el.prop('type', 'date');
				_showHideButton(false);
				el.trigger('viewport.slx.dateselector');
			} else {
				if (el.prop('type') === 'date') {
					that.changeFormat();
				} else {
					return;
				}
				// maintain default input type
				el.prop('type', _previousType || 'text');
				if (el.slxVal().length) { el.slxVal(t.toString(_getFormat())); }
				_showHideButton(true);
				el.trigger('viewport.slx.dateselector');
			}
		};

		var _formatParts;
		/** Change format of date value required for input type change. */
		(that.changeFormat = function() {
			var format = _getFormat();

			// get a part of the format
			var getPart = function(i, part) {
				return {
					index: i,
					length: part.length,
					value: part
				};
			};

			// get a delimeter object
			var getDelimeter = function(i, c) {
				return {
					index: i,
					char: c
				};
			};

			// get each format part
			var year, month, day;
			var formatParts = format.split(/[\/-]/);
			for (var i = 0; i < formatParts.length; i++) {
				var p = formatParts[i];
				if (p.indexOf('M') > -1) {
					month = getPart(i, p);
				} else if (p.indexOf('d') > -1) {
					day = getPart(i, p);
				} else if (p.indexOf('y') > -1) {
					year = getPart(i, p);
				}
			}

			// get delimeters
			var delimeters = [];
			for (var i = 0; i < format.length; i++) {
				var c = format[i];
				var isDelimeter = /[\/-]/.test(c);
				if (isDelimeter) {
					delimeters.push(getDelimeter(i, c));
				}
			}

			// set internal variable
			_formatParts = {
				month: month,
				day: day,
				year: year,
				delimeters: delimeters,
				length: formatParts.length
			};
		})();

		// validate date value and format
		var _validate = function (val, format) {
			// check for valid value
			if (!val || typeof val !== 'string') {
				return val;
			}

			// split date parts by delimeters
			var parts = val.split(/[\/-]/);
			if (parts.length < _formatParts.length && val || val.length < that.format.length) {
				return '';
			} else if (val.length) {
				// date parts
				var yy = _formatParts.year ? parts[_formatParts.year.index] : null;
				var mm = _formatParts.month ? parts[_formatParts.month.index] : null;
				var dd = _formatParts.day ? parts[_formatParts.day.index] : null;

				// validate date parts
				var m = mm ? parseInt(mm, 10) : 0;
				var d = dd ? parseInt(dd, 10) : 1;
				var y = yy ? parseInt(yy, 10) : 0;

				if (isNaN(m) || isNaN(d) || isNaN(y)) {
					return '';
				}

				m = (m === 0 ? 1 : m > 12 ? 12 : m) - 1;
				var days = new Date(y, m + 1, 0).getDate();
				d = d === 0 ? 1 : d > days ? days : d;
				return new Date(y, m, d).toString(format || _getFormat());
			}
		};

		// show hide calendar button
		var _showHideButton = function (val) {
			var grp = el.closest('.input-group, .slx-input-group, .input-group-readonly, .slx-input-group-readonly');
			var hasGrpChildren = grp.find('.input-group-addon, .input-group-prepend').length > 0;
			if (val === true && that.showIcon !== false && !that.readonly) {
				// show calendar button if enabled and editable
				_btn.parent().show();
				if (!hasGrpChildren && grp.hasClass('input-group-readonly')) {
					grp.removeClass('input-group-readonly').addClass('input-group');
				} else if (grp.hasClass('slx-input-group-readonly')) {
					grp.removeClass('slx-input-group-readonly').addClass('slx-input-group');
				}
			} else if (val === false) {
				// hide calendar button
				_btn.parent().hide();
				if (!hasGrpChildren && grp.hasClass('input-group')) {
					grp.removeClass('input-group').addClass('input-group-readonly');
				} else if (grp.hasClass('slx-input-group')) {
					grp.removeClass('slx-input-group').addClass('slx-input-group-readonly');
				}
			} else if (val === void 0 && (that.showIcon === false || that.readonly)) {
				// hide calendar button
				_showHideButton(false);
			}
		};
		
		/**
		 * Gets or sets the date value.
		 * @param {string} [v] Optional value to set.
		 * @param {boolean} [triggerChange=true] Trigger change event flag.
		 * @returns {string} The element value.
		 */
		that.value = function (v, triggerChange) {
			if (v === void 0) {
				// get value
				return el.slxVal().replace(/[^\d\/-]/g, '');
			} else {
				// set value
				var old = el.slxVal();
				var ischange = v !== old;
				var h = el.slxVal(v);
				// register previous and current values on change
				if (ischange) {
					el.data('original-val', that.toDateString(old));
					el.data('current-val', that.toDateString(v));
					// trigger change event if not being bypassed
					if (triggerChange !== false) {
						el.trigger('change');
					}
				}
				else that.close();
				return h;
			}
		};

		/**
		 * Gets or sets the display text.
		 * @param {string} [v] The text value to set. 
		 * @returns The display text.
		 */
		that.text = function (v) {
			if (v === void 0) {
				// get text
				return el.slxVal();
			} else {
				// set text
				if (v === '') { that.value(''); }
				return el.slxVal(v);
			}
		};

		/**
		 * Gets or sets the value as a {@link Date}.
		 * @param {Date} [v] The optional date to set.
		 * @returns The date.
		 */
		that.dateValue = function (v) {
			// get date value
			if (v === void 0) {
				var parts = el.slxVal().split(/[\D]/);
				var m = _formatParts.month ? parts[_formatParts.month.index] : '01';
				var d = _formatParts.day ? parts[_formatParts.day.index] : '01';
				var y = _formatParts.year ? parts[_formatParts.year.index] : '0000';

				return new Date(y, m - 1, d);
			}
			// set date value
			else if (v instanceof Date) { that.value(v.toString(that.format)); }
		};

		/**
		 * Converts the date into a string of the current format.
		 * @param {string} [v] The optional date format.
		 * @returns The formatted date string.
		 */
		that.toDateString = function (v) {
			var val = v || el.slxVal();
			// first validate value
			var dt = _validate(val, that.format);
			if (typeof dt === 'string') {
				// return if already string
				return dt;
			} else if (dt instanceof Date) {
				// convert Date to string by specified format
				return dt.toString(that.format);
			}
		};

		/**
		 * Gets the current format based on the viewport mode.
		 * @returns The current format for the control.
		 */
		that.currentFormat = function () {
			return _getFormat();
		}

		var _blurTimeout = null;
		/** Close calendar window. */
		that.close = function () {
			if (that.html5 && _isMobile && _dateSupported) { return; }
			that.container.removeClass('open');
			// trigger closed event and remove click listener
			el.off('click.slx').trigger('closed');
			x(document).off('click.slx');
			if (_blurTimeout !== null) { clearTimeout(_blurTimeout); }
			if (that.calendar !== null) { that.calendar._element.remove(); that.calendar = null; }
		};
		/** Open calendar window. */
		that.open = function () {
			if (that.html5 && _isMobile && _dateSupported) { return; }

			// close any already open window
			x('.slx-dateselector-calendar').each(function () {
				var c = x(this).slxControl('slxCalendar');
				if (c._parent && (that.calendar === null || that.calendar.prop('id') !== x(this).prop('id'))) { c._parent.close(); }
			});
			// open current control's window w/ current control's set date value
			that.container.addClass('open');
			var d = that.dateValue().isValid() ? that.value() : null;
			// build calendar
			that.calendar = new x.slx.calendar(x('<DIV/>').data('value', d), { id: that.id + '_calendar', _parent: that, view: that.view, lang: that.lang, format: that.format }).slxControl('slxCalendar');
			that.calendar._element.addClass('slx-dateselector-calendar');
			that.container.append(that.calendar._element);
			// adjust width
			var t = that.calendar._element.find('table.slx-calendar-calendar');
			if (t.length) {
				that.calendar._element.width(t.outerWidth() + 20);
			}
			el.trigger('opened');
			// add events for returning value from the calendar back to dateSelector
			that.calendar._element.on('click.slx.dateselector', function (event) { x(this).stopBubble(event); });
			that.calendar._element.on('keyup.slx.dateselector', function (event) {
				var k = event.keyCode || event.which;
				if (k === 27) { that.close(); }
			});
			that.calendar._element.on('change', function (event) {
				that.value(that.calendar.value());
				el.focus();
			});
			x(document).off('click.slx.dateselector').on('click.slx.dateselector', function () { that.close(); });
			el.off('click.slx.dateselector').on('click.slx.dateselector', function (event) { x(this).stopBubble(event); }).trigger('open');
		};

		/* initialization */
		(function () {
			_isMobile = global.innerWidth <= that.mobileMaxWidth;
			el.attr({ onchange: void 0, maxlength: 10, placeholder: that.mask, 'data-current-val': el.val() });

			// wrap in container div, if not already wrapped
			if (!that.container.length) {
				var grp = el.closest('.input-group, .slx-input-group');
				if (!grp.length) {
					grp = x('<DIV/>');
					// add class by bootstrap version
					if (x.slx.config.bootstrap) {
						grp.addClass('input-group');
					} else {
						grp.addClass('slx-input-group');
					}
					el.wrap(grp);
					grp = el.parent();
				}
				grp.wrap(x('<DIV/>').attr('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-dateselector-container'));
				that.container = grp.parent();
			}

			// add control CSS class and original value, if not already applied
			if (!el.hasClass('slx-dateselector')) { el.addClass('slx-dateselector'); }
			if (!el.data('original-val')) el.data('original-val', that.toDateString(el.slxVal()));

			// add calendar button, if not already added
			if (_btn.length === 0) {
				var grpBtn = x('<DIV/>');
				// add class to button group by bootstrap version
				if (x.slx.config.bootstrap === 3) {
					grpBtn.addClass('input-group-btn');
				} else if (x.slx.config.bootstrap === 4) {
					grpBtn.addClass('input-group-append');
				} else {
					grpBtn.addClass('slx-input-group-append');
				}
				// add button
				el.after(grpBtn.append(_btn = x('<BUTTON/>').attr({
					type: 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' }).addClass('slx-dateselector-icon')));
				_btn.prop('disabled', that.disabled);
				_btn.append(x('<SPAN/>').addClass(that.icon).attr('aria-hidden', 'true'));
				// add button class by bootstrap
				if (x.slx.config.bootstrap) {
					_btn.addClass('btn btn-control');
				} else {
					_btn.addClass('slx-btn slx-btn-control');
				}
			}

			// add aria
			if (!_btn.attr('aria-label')) {
				_btn.attr('aria-label', 'Choose date');
			}

			// show/hide and set input type by config settings
			_showHideButton();
			_setInputType();

			// encode value in case of HTML and trigger render event
			el.slxVal(x.htmlEncode(el.slxVal()));
			setTimeout(function () { el.trigger('render'); });
		})();

		/* events */
		(function () {
			// window/device resize event
			x(global).on('resize.slx.dateselector', function () {
				if (that.debug) {console.warn('DEBUG:', global.innerWidth, that.mobileMaxWidth);}
				_previousType = el.prop('type') !== 'date' ? el.prop('type') : 'text';
				_isMobile = global.innerWidth <= that.mobileMaxWidth;
				_setInputType();
			});
			el.off('change.slx.dateselector').on('change.slx.dateselector', function (event) {
				if (el.data('original-val') === that.toDateString()) {
					event.preventDefault();
				}

				el.data('current-val', that.toDateString());
				if (typeof that.onChange === 'function') {
					that.onChange.call(el[0], event);
				}
			});
			// calendar button click event
			_btn.off('click.slx.dateselector').on('click.slx.dateselector', function (event) {
				x(this).stopBubble(event);
				if (that.container.hasClass('open')) { that.close(); }
				else { that.open(); }
			});
			// input field onblur unfocus event
			el.off('focusout.slx.dateselector').on('focusout.slx.dateselector', function () {
				// set value to empty string if invalid date
				if (that.value() && !that.toDateString(that.value())) {
					el.slxVal('');
				}

				if (el.data('current-val') !== that.toDateString(that.value())) {
					var val = _validate(that.value());
					// update changed value
					if (val !== that.value()) {
						that.value(val, false);
					}
					// register current value
					else {
						el.data('current-val', that.toDateString(val));
					}
					// trigger change event
					el.trigger('change');
				}
				// close calendar after date selected
				that.close();
			});
			// input field onfocus event
			el.off('focusin.slx.dateselector').on('focusin.slx.dateselector', function () {
				el.data('original-val', that.toDateString(el.slxVal()));

				// close any open calendars
				that.close();
				x('.slx-dateselector-calendar').each(function () {
					var c = x(this).slxControl('slxCalendar');
					if (c._parent) { c._parent.close(); }
				});
			});
			// input field onkeydown event
			el.off('keydown.slx.dateselector').on('keydown.slx.dateselector', function (event) {
				// ignore if mobile and using HTML5
				if (_isMobile && that.html5) { return; }

				// capture input key and char
				var k = event.keyCode || event.which, char = String.fromCharCode(k);
				var v = el.val().replace(/[\D]/g, ''), val, enter = k === 13;
				if (enter) { return; }

				// get cursor position
				var cursor = el.getSelectionRange(), p = 0, delimeter;
				if (cursor !== null) {
					p = cursor.start;
					if (!event.shiftKey && !event.ctrlKey) {
						// prevent default behavior when outside value/cursor at maxlength
						if (k === 39 && p >= v.length + _formatParts.length) {
							event.preventDefault();
							return;
						}
						// update cursor position
						for (var d = 0; d < _formatParts.delimeters.length; d++) {
							delimeter = _formatParts.delimeters[d];
							if (p === delimeter.index - 1 && k === 39) {
								p++;
								break;
							} else if (p === delimeter.index + 1 && k === 37) {
								p--;
								break;
							}
						}
						el.setSelectionRange(p, p);
					}
				}

				// input keys to ignore
				var ignore = [9, 16, 17, 35, 36, 37, 38, 39, 40];
				if (ignore.contains(k)) { return; }

				// determine delete, cut/copy, paste behavior
				var del = [8, 46], cut = event.ctrlKey && k === 88, copy = event.ctrlKey && k === 67 || event.ctrlKey && k === 45, paste = event.ctrlKey && k === 86 || event.shiftKey && k === 45;
				if (!del.contains(k) && !copy && !paste && !cut) { event.preventDefault(); }
				else if (copy) { return; }
				else if (del.contains(k)) {
					if (k === 8) {
						// update cursor position
						var isDelimeter = _formatParts.delimeters.any(function (d) { return d.index === p - 1; });
						p -= isDelimeter ? 2 : 1;
					}
					if (cursor !== null) {
						event.preventDefault();
						el.slxVal(el.slxVal().substring(0, p) + el.slxVal().substring(cursor.end > p ? cursor.end : p + 1));
						// set cursor position after delete and fill w/ mask
						if (el.slxVal().length > 0) {
							el.slxVal(_fillMask());
							el.setSelectionRange(p, p);
						}
					}
					return;
				}

				// validate numeric value or slash
				var slash = k === 111 || !event.shiftKey && k === 191;
				if (k >= 96 && k <= 105) { k -= 48; char = String.fromCharCode(k); }

				// check for cursor at slash
				if (cursor !== null) {
					for (var d = 0; d < _formatParts.delimeters.length; d++) {
						delimeter = _formatParts.delimeters[d];
						if (p === delimeter.index) {
							p++;
							el.setSelectionRange(p, p);
							break;
						}
					}
				}

				// ignore non-numeric characters
				if ((slash && that.format.indexOf('/') === -1) || (!slash && isNaN(char)) || (slash && cursor === null)) { return; }

				// allow slash to advance cursor when within 1 index prior, otherwise, do nothing
				if (slash && _formatParts.delimeters.length) {
					var prev = 0;
					for (var d = 0; d < _formatParts.delimeters.length; d++) {
						delimeter = _formatParts.delimeters[d];
						if (delimeter.char === '/' && p >= prev && p < delimeter.index && p !== delimeter.index - 1) {
							return;
						}
						prev = delimeter.index;
					}
					// reject slash after last occurrence
					if (p > prev) return;
				}

				if (cursor === null) {
					// set value w/ mask for empty cursor
					el.slxVal(_fillMask(char));
					p = el.slxVal().indexOf('_');
					p = p === -1 ? el.slxVal().length : p;
				} else {
					// determine cursor w/ mask
					if (p >= that.mask.length) { return; }
					var s = cursor.start;
					for (var d = 0; d < _formatParts.delimeters.length; d++) {
						delimeter = _formatParts.delimeters[d];
						if (p > delimeter.index) {
							s--;
						}
					}

					// check for slash input
					var len = that.format.replace(/[\W]/g,'').length;
					if (slash && v.length <= len) {
						if (v.length <= s) {
							// when entering a new value
							v = v.splice(s-1, 0, '0');
							p++;
						} else if (v.charAt(s-1) !== '0') {
							// when overwriting an existing value
							v = v.splice(s, 1, '').splice(s-1, 0, '0');
							p++;
						} else {
							// if preceding number is a zero, just skip to next number group
							p += 2;
							el.setSelectionRange(p, p);
							return;
						}
					} else if (v.length < len) {
						// default digit entry
						v = v.splice(s, 0, char);
					}

					// build new value from splicing mask with value
					val = that.mask;
					for (var i = 0, n = 0; i < val.length; i++, n++) {
						var atSlash = val.charAt(i) === '/';
						if (atSlash) { n--; }
						var c = i === p ? char : !atSlash && v.charAt(n) || val.charAt(i);
						val = val.splice(i, 1, c);
					}
					p++;
					// update cursor position and update value
					for (var d = 0; d < _formatParts.delimeters.length; d++) {
						delimeter = _formatParts.delimeters[d];
						if (p === delimeter.index) {
							p++;
							break;
						}
					}
					el.slxVal(val);
					el.slxVal(_fillMask());
				}
				el.setSelectionRange(p, p);
			});

			// create observer to listen for disabled and readonly property changes
			var observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.attributeName === 'disabled') {
						// disabled prop change
						that.disabled = el.prop('disabled');
						_btn.prop('disabled', that.disabled);
					} else if (mutation.attributeName === 'readonly') {
						// readonly prop change
						that.readonly = el.prop('readonly');
						// test for date input support and mobile mode
						if (_dateSupported === null) { _dateSupported = _testDateSupport(); }
						if (!_isMobile || !_dateSupported) {
							_showHideButton(!that.readonly);
						}
					}
				});
			});

			observer.observe(el[0], { attributes: true });
		})();

		// register control w/ element
		el[0].slxDateSelector = this;
		el[0].isSlxControl = true;

		return el;
	};
	// update constructor
	x.slx.dateSelector.prototype = Object.create(x.slx.base.prototype);
	x.slx.dateSelector.prototype.constructor = x.slx.dateSelector;

	/* extenders */
	x.slx.extend({
		// add control init extension
		slxDateSelector: function () {
			var slx = this.slxControl('slxDateSelector', arguments) || new x.slx.dateSelector(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof slx[arg] === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	
	// register control
	x.slx.register('slxDateSelector', x.slx.slxDateSelector);

	// initialize all controls by CSS class
	x(function () { x('.slx-dateselector').each(function () { x(this).slxDateSelector(); }); });

	return x;
})(window || this);